<div id="transaction-details-section">
    <span id="subtitle">Standing authorization details</span>
    <a *ngIf="(createRequestStep$ | async) === 'review' && !isInrFromTable" class="no-print" id="edit-link" (click)="onEditClicked()">Edit</a>

    <div id="resp-table">
        <div id="resp-table-body">
            <div class="resp-table-row">
              <div class="table-body-cell">
                <mm-label-group id="wireDetails_transactionType" data-testid="wireDetails_transactionType"
                [title]="labels.transactionType" [data]="transactionType"></mm-label-group>
              </div>
              <div class="table-body-cell">
                <mm-label-group id="wireDetails_isThereAnIntermediaryInstitution"
                data-testid="wireDetails_isThereAnIntermediaryInstitution" class="column"
                [title]="labels.isThereAnIntermediaryInstitutionHorizontalLabel" [data]="intermediarySelection | titlecase">
            </mm-label-group>
              </div>
          </div>

          <div class="dashed-border"></div>

        <div *ngIf="!isIntermediaryYes" class="resp-table-row">
            <div class="table-body-cell">
              <mm-label-group id="wireDetails_aba" data-testid="wireDetails_aba" title = {{saAbaLabel}}
                  [data]="aba">
              </mm-label-group>
            </div>
            <div class="table-body-cell">
                <mm-label-group id="wireDetails_bankDetails" data-testid="wireDetails_bankDetails"
                title = {{saAbaInfoLabel}} [multilineData]="receivingBankDetails">
                </mm-label-group>
            </div>
          </div>

          <div *ngIf="isIntermediaryYes">
            <div id="resp-table">
                <div id="resp-table-body">
                    <div class="resp-table-row">
                        <span [ngClass]="'table-body-cell'" class="schwab-grey font-bold padding-y-0" id="intermediary"
                            data-testid="intermediary-input">
                            Intermediary
                        </span>
                        <span [ngClass]="'table-body-cell'" class="schwab-grey padding-y-0" id="bank-aba"
                            data-testid="bank-aba-input" *ngIf="aba">
                            <mm-label-group id="wireDetails_aba_label" class="column loa loaToDetails"
                                data-loafieldname="{{pdfLabelsToDetails.receivingBankAbaNumber}}"
                                data-testid="wireDetails_aba_label" [title]="saAbaLabel" [data]="aba">
                            </mm-label-group>
                        </span>
                        <span [ngClass]="'table-body-cell'">
                            <mm-label-group id="wireDetails_bankDetails_label" data-testid="wireDetails_bankDetails_label"
                                [title]="saAbaInfoLabel" [multilineData]="receivingBankDetails">
                            </mm-label-group>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="isIntermediaryYes" id="resp-table">
            <div id="resp-table-body">
                <div class="resp-table-row">
                    <span [ngClass]="'table-body-cell'" class="padding-y-0 schwab-grey font-bold">
                        Recipient bank
                    </span>
                    <label id="wireDetails_intermediaryAccountNumberHorizontalLabel_label"
                        data-testid="wireDetails_intermediaryAccountNumberHorizontalLabel_label" [ngClass]="'table-body-cell'"
                        class="padding-y-0 schwab-grey" *ngIf="intermediaryAccountNumber">
                        {{intermediaryAccountNumberLabel}}
                    </label>
                    <label data-testid="wireDetails_intermediaryDetails_label" id="wireDetails_intermediaryDetails_label"
                        [ngClass]="'table-body-cell'" class="padding-y-0 schwab-grey">
                        Bank information
                    </label>
                </div>
                <div class="resp-table-row">
                    <span [ngClass]="'table-body-cell'" class="font-arial padding-y-0">
        
                    </span>
                    <span id="wireDetails_intermediaryAccountNumberHorizontalLabel"
                        data-testid="wireDetails_intermediaryAccountNumberHorizontalLabel" [ngClass]="'table-body-cell'"
                        class="font-arial padding-y-0" *ngIf="intermediaryAccountNumber">
                        {{intermediaryAccountNumber}}
                    </span>
                    <span data-testid="wireDetails_intermediaryDetails" id="wireDetails_intermediaryDetails"
                        [ngClass]="'table-body-cell'" class="font-arial padding-y-0" style="white-space: pre-line;">
                        {{intermediaryDetail}}
                    </span>
                </div>
            </div>
        </div>
          
          <div class="dashed-border"></div>
      
          <div class="resp-table-row">
              <div *ngIf="!isIrsAba" class="table-body-cell">
                  <mm-label-group id="wireDetails_receivingBankAccountNumber"
                  data-loafieldname="{{pdfLabelsToDetails.beneficiaryAccountNumber}}"
                  data-testid="wireDetails_receivingBankAccountNumber" class="column loa loaToDetails"
                  [title]="labels.isoReceivingBankAccountNumber" [data]="toAccount">
              </mm-label-group>
              </div>
              <div class="table-body-cell">
                  <mm-label-group id="wireDetails_recipientName" data-loafieldname="{{pdfLabelsToDetails.recipientName}}"
                  data-testid="wireDetails_recipientName" class="column loa loaToDetails" [title]="labels.recipientName"
                  [multilineData]="recipientName">
              </mm-label-group>
              </div>
              <div class="table-body-cell">
                  <mm-label-group id="wireDetails_receivingAccountHolder" data-testid="wireDetails_receivingAccountHolder"
                  class="column white-space" [title]="labels.recipientAddress" [multilineData]="receivingAccountHolder">
              </mm-label-group>
              </div>
              <div class="table-body-cell">
                  <mm-label-group id="wireDetails_recipient" data-testid="wireDetails_recipient" class="column"
                  [title]="labels.recipientHorizontalLabel" [data]="recipient">
              </mm-label-group>
              </div>
          </div>
          <div *ngIf = "isIrsAba" class="dashed-border"> </div>
          <div class="resp-table-row">
                <div *ngIf="isIrsAba" class="table-body-cell">
                    <mm-label-group id="wireDetails_taxPayerId" data-testid="wireDetails_taxPayerId"
                        [title]="labels.taxPayerId" [data]="(taxPayerId | maskAccountNumber)" 
                        class="loa loaSubmitDetails" data-loafieldname="{{pdfLabelsSubmitDetails.taxId}}">
                    </mm-label-group>
                </div>
                <div *ngIf="isIrsAba" class="table-body-cell">
                    <mm-label-group id="wireDetails_taxTypeCode" 
                    data-testid="wireDetails_taxTypeCode" class="column"
                    [title]="labels.taxTypeCode" [data]="taxTypeCode"
                        class="loa loaSubmitDetails" data-loafieldname="{{pdfLabelsSubmitDetails.taxTypeCode}}">
                </mm-label-group>
                </div>
          </div>
          <div *ngIf="isIra" class="dashed-border"></div> 
          <div  class="resp-table-row">
            <div *ngIf="isIra" class="table-body-cell">
                <mm-label-group id="federal-tax-percentage" data-loafieldname="{{pdfLabelsSubmitDetails.fedTax}}"
                data-testid="wireDetails_federalTaxPercent" class="column loa loaSubmitDetails"
                [title]="labels.federalTax" [data]="fedTaxPercent">
            </mm-label-group>
            </div>
            <div *ngIf="isIra" class="table-body-cell">
                <mm-label-group id="state-tax-percentage" data-loafieldname="{{pdfLabelsSubmitDetails.stateTax}}"
                data-testid="wireDetails_stateTaxPercent" class="column loa loaSubmitDetails" [title]="saStateTaxLabel"
                [data]="stateTaxPercent">
            </mm-label-group>
            </div>
          
            <div *ngIf="nickname" class="table-body-cell">
                <mm-label-group id="wireDetails_nickname" data-testid="wireDetails_nickname" class="column"
                [title]="labels.authorizationNickname" [data]="nickname">
            </mm-label-group>
            </div>
        </div>
        <sdps-divider *ngIf="transmissionNotes" variation="secondary"></sdps-divider>
        <div  class="resp-table-row">
            <div *ngIf="transmissionNotes" class="table-body-cell no-padding width-100">
                <mm-label-group id="wireDetails_transmissionNotes"
                data-loafieldname="{{pdfTransmissionNotesLoa}}"
                data-testid="wireDetails_transmissionNotes" class="column loa loaSubmitDetails"
                [title]="transmissionNotesLabel" [data]="transmissionNotes">
                </mm-label-group>
            </div>
        </div>
        </div>
    </div>
    <sdps-divider variation="secondary"></sdps-divider>
</div>
